import type { Mission } from '../missions.ts'

export const exim: Mission = {
  id: "exim",
  name: "Export-Import Bank of the United States",
  short: "EXIM",
  call: "Exports",
  kind: "independent",
  url: "https://www.exim.gov/",
  established: 1934,
  palette: {
    primary: "#005088",
    secondary: "#886828",
    accent: "#b09038",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Export-Import_Bank.svg",
  },
  motif: "column",
  mission: {
    text: "EXIM is an independent Executive Branch agency with a mission of supporting American jobs by facilitating the export of U.S. goods and services.",
    url: "https://www.exim.gov/about",
  },
  fact: {
    text: "EXIM is the official export credit agency of the United States, and its charter requires that every transaction it authorizes demonstrate a reasonable assurance of repayment.",
    url: "https://www.exim.gov/about",
  },
  seal: {
    file: "public/seals/exim.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Export-Import_Bank.svg",
  },
  identifier: {
    about: "https://www.exim.gov/about",
    accessibility: "https://www.exim.gov/accessibility",
    foia: "https://www.exim.gov/about/foia",
    noFear: "https://www.exim.gov/about/careers/no-fear",
    oig: "https://eximoig.oversight.gov/",
    performance: "https://www.exim.gov/news/reports",
    privacy: "https://www.exim.gov/privacy-and-security-policy",
  },
  media: {
    photos: [
      {
        file: "/media/exim-lafayette-building.jpg",
        small: "/media/exim-lafayette-building-sm.jpg",
        alt: "The limestone Lafayette Building, headquarters of the Export-Import Bank, on a Washington street corner",
        title: "Lafayette Building, 811 Vermont Avenue NW, Washington, D.C.",
        creator: "APK",
        source: "https://commons.wikimedia.org/wiki/File:Lafayette_Building_-_November_2023.jpg",
        license: "CC BY 4.0",
      },
      {
        file: "/media/exim-sign.jpg",
        small: "/media/exim-sign-sm.jpg",
        alt: "A bronze plaque reading Export-Import Bank of the United States on a polished stone wall reflecting nearby buildings",
        title: "Export-Import Bank of the United States",
        creator: "Tony Webster",
        source: "https://commons.wikimedia.org/wiki/File:Export-Import_Bank_of_the_United_States_(53815498282).jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
